import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ContentPreview } from './components/ContentPreview';
import { ProductReveal } from './components/ProductReveal';
import { CountdownTimerSection } from './components/CountdownTimerSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ValueSummary } from './components/ValueSummary';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { WhyPerfect } from './components/WhyPerfect';
import { AboutSection } from './components/AboutSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // UTMify Pixel
    const win = window as any;
    win.pixelId = '69a86f2446b20f10b49a81cb';
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-spice-50 font-body text-gray-900 selection:bg-spice-300 selection:text-spice-900" data-id="element-0">
      <StickyAlertBar data-id="element-1" />

      <main className="pt-10 md:pt-12" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPointsSection data-id="element-4" />
        <ContentPreview data-id="element-5" />
        <ProductReveal data-id="element-6" />
        <CountdownTimerSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <ValueSummary data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FaqSection data-id="element-12" />
        <WhyPerfect data-id="element-13" />
        <AboutSection data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}